"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.currencyRoutes = void 0;
exports.currencyRoutes = [
    {
        name: 'currency.getRate',
        path: '/rate/:from/:to',
        method: 'GET'
    },
    {
        name: 'currency.getAllRates',
        path: '/rates',
        method: 'GET'
    },
    {
        name: 'currency.updateRates',
        path: '/update',
        method: 'POST'
    }
];
